import { enableIndexedDbPersistence } from 'firebase/firestore';
import { db } from '../config/firebase.js';
import { logError, logInfo } from './logger.js';

let initialized = false;
let persistenceEnabled = false;
let initializationPromise = null;

export const initializeDatabase = async () => {
  console.log('Database initialization starting...');

  // Return existing initialization promise if one exists
  if (initializationPromise) {
    return initializationPromise;
  }

  // Create new initialization promise
  initializationPromise = (async () => {
    if (initialized) {
      console.log('Database already initialized');
      return true;
    }

    try {
      console.log('Attempting to enable persistence...');
      if (!persistenceEnabled) {
        try {
          await enableIndexedDbPersistence(db, {
            synchronizeTabs: true,
            experimentalForceOwningTab: true
          });
          persistenceEnabled = true;
          console.log('Persistence enabled successfully');
        } catch (err) {
          if (err.code === 'failed-precondition') {
            // Multiple tabs open, persistence can only be enabled in one tab.
            console.log('Persistence already enabled in another tab');
          } else if (err.code === 'unimplemented') {
            console.error('Browser does not support persistence');
            return false;
          }
        }
      }

      // Handle cleanup on page close
      window.addEventListener('unload', () => {
        if (db) {
          // Properly close IndexedDB connections
          const closePromise = db.terminate?.();
          if (closePromise) {
            closePromise.catch(() => {
              // Ignore errors during cleanup
            });
          }
        }
      });

      initialized = true;
      console.log('Database initialization completed successfully');
      return true;
    } catch (error) {
      console.error('Database initialization failed:', error);
      initializationPromise = null; // Clear failed promise
      return false;
    }
  })();

  return initializationPromise;
};